export default "__VITE_ASSET__Bq5fRbte__"